
<div>
  <div class="c-section grey">
    <div class="c-section white">
      <div class=cta v-if="loading">
        <div class="spinner">
          <img src="@assets/images/_icon-spinner.svg" alt="Loading Spinner">
        </div>
      </div>
      <matrix v-else
      :fetching-message="'No submissions.'"
      class="clear-table associated-form-submissions"
      :has-footer="true"
      :has-data="visibleSubmissions.length > 0">
      <template slot="table-header" v-if="visibleSubmissions.length">
        <t-prefix is-heading/>
        <t-column is-heading>
          <sort-column v-if="hasSort" :value="FormListSortColumn.FormName" v-bind="currentSortDetails" @click="reSortSubmissions">
            Form Name
          </sort-column>
          <template v-else>
            Form Name
          </template>
        </t-column>
        <t-column is-heading>
          <sort-column v-if="hasSort" :value="FormListSortColumn.SubmissionDate" v-bind="currentSortDetails" @click="reSortSubmissions">
            Submitter and Submission Date
          </sort-column>
          <template v-else>
            Submitter and Submission Date
          </template>
        </t-column>
        <t-column is-heading>
          <sort-column v-if="hasSort" :value="FormListSortColumn.StatusChangeDate" v-bind="currentSortDetails" @click="reSortSubmissions">
            Status
          </sort-column>
          <template v-else>
            Status
          </template>
        </t-column>
      </template>
      <template slot="table-body">
        <template v-for="submission in visibleSubmissions">
          <t-row class="form form-submission-listing" :key="submission.id">
            <t-prefix>
              <a :href="`/submissions/${submission.id}`" :class="{'disabled-link': isPreview || isInDetailViewEditMode}">
                <icon class="form"></icon>
              </a>
            </t-prefix>
            <t-column class="row-title">
              <a :href="`/submissions/${submission.id}`" :class="{'disabled-link': isPreview || isInDetailViewEditMode}">
                <span>{{ submission.title }}</span>
              </a>
            </t-column>
            <t-column>
              <template v-if="submission.submitted_at">
                <b>{{submission.submitter_name}}</b> on
                <br>
                {{ toDatetime(submission.submitted_at) }}
              </template>
              <template v-else>
                Not yet submitted.
              </template>
            </t-column>
            <t-column table-element>
              <crayon :color="[submission.statusClass]">{{submission.current_application_status_name}}</crayon> {{submission.statusTimePrefix}}
              <br>
              {{ statusUpdatedAt(submission) }}
            </t-column>
          </t-row>
        </template>
      </template>
    </matrix>
    </div>
    <div class="container align-right" v-if="visibleSubmissions.length > 0">{{countDisplay}}</div>
  </div>
  <template v-if="shouldShowMore && !loading">
    <div class="cta">
      <slot name="cta">
        <button class="btn-link"
                type="button"
                @click="showMore">Show More</button>
      </slot>
    </div>
  </template>
</div>
